import React from "react";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";

import ChartCard from "@/components/dashboard/chart-card";
import { ChartConfig, ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { cn } from "@/lib/utils";

interface LineChartGraphProps {
    chartContainerClassname?: string;
    title: string;
    value?: number;
    subtitle?: string;
    chartConfig: ChartConfig;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    chartData: any[];
}

const LineChartGraph: React.FC<LineChartGraphProps> = ({ chartContainerClassname, title, value, subtitle, chartConfig, chartData }) => {
    return (
        <ChartCard title={title} value={value} subtitle={subtitle}>
            <ChartContainer config={chartConfig} className={cn("h-[507px] min-h-[200px] w-full", chartContainerClassname)}>
                <LineChart accessibilityLayer data={chartData}>
                    <CartesianGrid vertical={false} />
                    <XAxis dataKey="month" tickLine={false} tickMargin={10} axisLine={false} tickFormatter={(value) => value.slice(0, 3)} />
                    <YAxis />
                    <ChartTooltip content={<ChartTooltipContent />} />
                    <ChartLegend content={<ChartLegendContent />} />
                    {Object.keys(chartConfig).map((key) => {
                        return <Line key={key} dataKey={key} type={"natural"} fill={chartConfig[key].color} radius={4} />;
                    })}
                </LineChart>
            </ChartContainer>
        </ChartCard>
    );
};

export default LineChartGraph;
